export const STORAGE_LOCAL = {
    TOKEN: 'token',
    IS_REDIRECTED: 'isRedirected', 
    EMAIL_DIRECTED: 'email_directed'
};
  